import React, { useState } from 'react';
import { useStyles } from '../../../lib/hooks/useStyles';
import theme from '../../../lib/themes/linkpick/new_theme';

export const TextField = ({ 
  onChange,
  onBlur,
  type = "text",
  value,
  name,
  required = false,
  disabled = false,
  error = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { classes, css } = useStyles(styles);

  
  const handleChange = (e) => {
    onChange && onChange(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };

  return (
    <div className={css(theme.components.textField.container)}>
      <input
        type={type}
        className={css(
          theme.components.textField.input,
          error && theme.components.textField.inputError
        )}
        value={value}
        name={name}
        required={required}
        disabled={disabled}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    </div>
  );
};
  

const styles = () => ({
  container: theme.components.textField.container,
  input: theme.components.textField.input
});